import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Curation.scss';

/**
  * @group THD Home Components
  * Curation
  */


// added temporarily
if (typeof window != "undefined" && !window.THD_GLOBAL) {
  window.THD_GLOBAL = {};
}

class Curation extends React.Component {
  static async getThdCuration() {
    const { default: curationWidget } = await import(/* webpackChunkName: "common" */ 'thd-curation');
    return curationWidget;
  }

  async componentDidMount() {
    const curationWidget = await Curation.getThdCuration();
    curationWidget.init();
  }

  render() {
    const { opts } = this.props;
    const { options } = opts;
    return (
      <div className="grid">
        <div className="col__12-12">
          <div
            id={opts.id}
            className={classNames(
              'js-curation-container',
              {
                'js-carousel-container': options.isCarouselView,
                'js-grid-container': options.isGridView,
              }
            )}
            data-name={options.name}
            data-view-type={options.viewType}
            data-curation-id={options.curationId}
            data-number-products={options.numberProducts}
            data-show-product-label={options.showProductLabel}
            data-show-reviews={options.showReviews}
            data-show-price={options.showPrice}
            data-show-title={options.showTitle}
            data-grid-size={options.gridSize}
            data-show-add-to-cart={options.showAddToCart}
            data-show-add-to-list={options.showAddToList}
          />
        </div>
      </div>
    );
  }
}

Curation.propTypes = {
  opts: PropTypes.shape({
    options: PropTypes.shape({
      name: PropTypes.string,
      curationId: PropTypes.string,
      numberProducts: PropTypes.string,
      viewType: PropTypes.string,
      isGridView: PropTypes.bool,
      isCarouselView: PropTypes.bool,
      showProductLabel: PropTypes.bool,
      gridSize: PropTypes.string,
      showPrice: PropTypes.bool,
      showReviews: PropTypes.bool,
      showTitle: PropTypes.bool,
      showAddToList: PropTypes.bool,
      showAddToCart: PropTypes.bool
    }),
    id: PropTypes.string,
  }).isRequired,
};

export default Curation;
